import { useQuery } from "@tanstack/react-query";
import { masterTableKeys } from "@/queries/masterTableKeys";
import { FILTER_TYPES_MASTER, MasterFilter } from "@/types/master-filter";
import type { ParameterTableMap } from "@/interfaces/table-master";
import { getParameterTable } from "@/services/get-parameter-table/getParameterTable";


export interface UseParameterTableOptions {
  enabled?: boolean;
}

export const useParameterTableService = (
  filter: MasterFilter = { type: FILTER_TYPES_MASTER.PARAMETERS },
  options: UseParameterTableOptions = {}
) => {
  const { enabled = true } = options;

  const parameterQuery = useQuery<ParameterTableMap[] | null>({
    queryKey: masterTableKeys.byTypeFilter(filter),
    queryFn: getParameterTable,
    enabled: enabled && !!filter,
  });

  return {
    ...parameterQuery
  };
};
